<template>
  <v-container>
    <helmet-provider>
      <div>
        <helmet>
          <title>BepInExの導入 - 日本語化ファイル置き場 -</title>
          <meta name='description' content='主にSteamで配信されている海外ゲームの日本語化Modに関するサイトです。'>
        </helmet>
      </div>
    </helmet-provider>
    <page-title 
      title='BepInExの導入'/>
    <page-contents 
      :contents=info />
    <site-info 
      :infos=links />
    <bep-in-ex-steps />
  </v-container>
</template>


<script>
import { HelmetProvider, Helmet } from "@jnields/vue-helmet";

import PageTitle from '@/components/PageTitle.vue'
import PageContents from '@/components/PageContents.vue'
import SiteInfo from '@/components/SiteInfo.vue'
import BepInExSteps from '@/components/BepInExSteps.vue'

export default {
  components: {
    PageTitle,
    PageContents,
    SiteInfo,
    BepInExSteps,
    HelmetProvider, 
    Helmet
  },
  data(){
    return{
      info: [
        'BepInExは、Unityや.NETフレームワークで作られたゲームに実行時にパッチをあて処理を追加することでプラグインの導入を可能にするフレームワークです。',
        'これまでは、日本語化というとデータファイルを直接書き換えるものが多く、アップーデートのたびに対応が必要でしたが、実行時に追加された処理内でデータの書き換えを行えるため、アップデートの影響を受け辛くなります。\
        また、フォントやフォントサイズを変更したり、データファイルに記述されていない文言の書き換えを行うこともできます。',
      ],

      links: [
        {
          name: 'ドキュメント',
          link: 'https://docs.bepinex.dev/index.html'
        },
        {
          name: 'リポジトリ',
          link: 'https://github.com/BepInEx/BepInEx'
        }
      ]
    }
  }
};
</script>
